import React from 'react';
import { Checkbox as AntCheckbox } from 'antd-v5';
import './style.less';
function Checkbox(props) {
  const { ...nativeProps } = props;

  return <AntCheckbox {...nativeProps} className='ui-checkbox' />;
}
Checkbox.Group = AntCheckbox.Group;
export default Checkbox;
